import { useLanguagePreference } from "../model/language-preference-store";

/**
 * Gets the current language/locale from the language preference store.
 * This is a convenience function to avoid repeating `useLanguagePreference.getState().language`.
 */
export const getCurrentLang = () => {
  return useLanguagePreference.getState().language;
};
